import {getType, resolveIdentifier, types} from "mobx-state-tree";
import lodash from "lodash";
import Parameter from "../../../../models/Parameter";
import CountParamsStore from "../../../../stores/domain/parameters/CountParamsStore";

export const CountParamsTypeSelectState = types.model('CountParamsTypeSelectState',{
  selectStateUuid: types.identifier,
  store: types.maybe(types.reference(CountParamsStore)),
  selectedCountParameters: types.optional(types.array(types.safeReference(Parameter)), []),
}).volatile((self)=>({
  notifySelect: types.str,
})).actions((self) => ({
  setConsumer(f){
    self.notifySelect = f
  },
  selectParameters(e) {
    if (lodash.isArray(e)) {
      self.selectedCountParameters = e?.map(g => {
        return resolveIdentifier(Parameter, self, g?.uuid || g)
      })
    } else if (e) {
      self.selectedCountParameters = e
    }
  },
})).views( (self) => ({
  options() {
    return self.store.getCodeParameters() || [];
  },
}))
